import * as yup from 'yup'

export const schema = yup
  .object()
  .shape({
    image: yup
      .mixed()
      //@typescript-eslint/no-explicit-any
      .test('file', 'A imagem é obrigatória!', (value: any) => {
        if (value) return true
        return false
      })
      .required('A imagem é obrigatória!'),
    name: yup.string().required('Nome do lanche obrigatório!'),
    snack: yup.string().required('Tipo do lanche é obrigatório!'),
    description: yup.string().required('Descricão é obrigatorio!'),
    price: yup.number().required('Preço é obrigatório!'),
  })
  .required()

export type FieldSnack = yup.InferType<typeof schema>
